module.exports = __webpack_public_path__ + "img/Buymeacoffee.47bcf124.svg";